// CUSTOMER LIST
export const CUSTOMER_LIST_COLUMN = "CUSTOMER_LIST_COLUMN";
